import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, model, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslatePipe } from '@ngx-translate/core';
import { DrawerModule } from 'primeng/drawer';
import { TooltipModule } from 'primeng/tooltip';
import { ICRUDOptions } from '@phx-erp/shared';
import { NotificationService } from '../../../../../@core/services/notification/notification.service';
import { GET_ADDRESS_POSTAL_LINKS_DROP_DOWN_LIGHT } from '../../../../../data/definitions/address-postal-link-dropdown-fragment.definition';
import { Address, AddressPostalLink, DocumentDirection } from '../../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../../shared/components/genericBaseModelDropDown';
import { AddressPostalLinkService } from '../../../services/address-postal-link.service';
import { AddressHeaderCardWidgetComponent } from '../../address-header-card/address-header-card-widget/address-header-card-widget.component';

@Component({
  selector: 'app-address-postal-link-drop-down',
  templateUrl: './address-postal-link-drop-down.component.html',
  styleUrls: ['./address-postal-link-drop-down.component.scss'],
  providers: [AddressPostalLinkService],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    CommonModule,
    DrawerModule,
    AddressHeaderCardWidgetComponent,
    TooltipModule,
    TranslatePipe,
  ]
})
export class AddressPostalLinkDropDownComponent extends GenericBaseModelDropDown<AddressPostalLink> implements OnInit, OnChanges {

  @Input()
  showOnlyDebitors;

  @Input()
  showOnlyCreditors;

  direction = model<DocumentDirection>();
  DocumentDirection = DocumentDirection;

  sidebarVisible = false;

  /** No in use at the moment */
  existingAddresses = model<Address[]>([]);

  constructor(public service: AddressPostalLinkService,
    private notification: NotificationService,
    private renderer: Renderer2) {
    super(service, "AddressPostalLink");

    // effect(() => {
    //   if (this.existingAddresses() && this.existingAddresses().length > 0) {
    //     // filter out to show item that are not in the existingAddresses
    //     // let result = this.itemsSig().filter(item => !this.existingAddresses().find(existing => existing.id === item.id));
    //   }
    // });

    this.queryOptions = {
      fragment: GET_ADDRESS_POSTAL_LINKS_DROP_DOWN_LIGHT
    }
  }

  ngOnChanges(change: any): void {
    // super.ngOnChanges(change);
    if ((change?.showOnlyDebitors?.previousValue !== undefined && change?.showOnlyDebitors?.currentValue != change?.showOnlyDebitors?.previousValue) ||
      (change?.showOnlyCreditors?.previousValue !== undefined && change?.showOnlyCreditors?.currentValue != change?.showOnlyCreditors?.previousValue)) {
      if (this.initialFetchExecuted)
        this.refresh();
    }

  }

  async ngOnInit(): Promise<void> {
    if (this.initialFetchExecuted)
      if (this.props?.onlyManufacturer) {
        this.refresh();
      }

    // await super.ngOnInit();

    this.value.subscribe((x: AddressPostalLink) => {
      if ((this.direction() === DocumentDirection.IN && x?.address?.documentBlockIn) || (this.direction() === DocumentDirection.OUT && x?.address?.documentBlockOut)) {
        if ((this.direction() === DocumentDirection.IN && x?.address?.documentBlockIn) && (this.direction() === DocumentDirection.OUT && x?.address?.documentBlockOut))
          this.notification.error(this.i18n.translate(_('crm.has-document-block')));
        if ((this.direction() === DocumentDirection.IN && x?.address?.documentBlockIn))
          this.notification.error(this.i18n.translate(_('crm.has-document-block-in')));
        if ((this.direction() === DocumentDirection.OUT && x?.address?.documentBlockOut))
          this.notification.error(this.i18n.translate(_('crm.has-document-block-out')));
        this.clear();
      }
    })
    super.ngOnInit();
  }

  generateNameLabel(item: AddressPostalLink) {

    if (typeof item === 'string') {
      return ''
    }

    let name = item?.address?.name || '';

    if (item?.address?.firstName)
      name += ` ${item.address?.firstName}`;
    if (item?.address?.lastName)
      name += ` ${item.address?.lastName}`;

    if (this.showOnlyCreditors && item?.address?.creditor?.identifier)
      name = `${item?.address?.creditor?.identifier} ${name}`;

    if (this.showOnlyDebitors && item?.address?.debitor?.identifier)
      name = `${item?.address?.debitor?.identifier} ${name}`;

    if (!this.showOnlyCreditors && !this.showOnlyDebitors)
      name = `${name}`;

    if (name === '') {
      name = this.i18n.translate(_('crm.address-error-name'));
      // if (item?.address?.defaultEmail) {
      //   name = `Address: Undefined, Email: ${item.defaultEmail}`
      // } else if (item?.address?.email2) {
      //   name = `Address: Undefined, Email: ${item.email2}`
      // }
    }

    //  if none set as unknown
    // if (name === '') {
    //   name = 'Address: Undefined';
    // }

    return name;
  }

  generatePostalAddressLabel(item: AddressPostalLink) {
    let postalAddressLabel: string = "";
    if (item?.postalAddress?.street)
      postalAddressLabel += `${item?.postalAddress?.street}`;
    if (item?.postalAddress?.street && item?.postalAddress?.streetNumber)
      postalAddressLabel += ` `;
    if (item?.postalAddress?.streetNumber)
      postalAddressLabel += `${item?.postalAddress?.streetNumber}`;
    if ((item?.postalAddress?.street || item?.postalAddress?.streetNumber) && item?.postalAddress?.postalCode)
      postalAddressLabel += `, `;
    if (item?.postalAddress?.postalCode)
      postalAddressLabel += `${item?.postalAddress?.postalCode}`;
    if (item?.postalAddress?.postalCode && item?.postalAddress?.city || item?.postalAddress?.countryIso)
      postalAddressLabel += ` `;
    if (item?.postalAddress?.city)
      postalAddressLabel += `${item?.postalAddress?.city}`;
    if (item?.postalAddress?.city && item?.postalAddress?.countryIso)
      postalAddressLabel += `, `;
    if (item?.postalAddress?.countryIso)
      postalAddressLabel += `${item?.postalAddress?.countryIso}`;
    return postalAddressLabel;
  }

  override executeSearch(searchInput?: any, options?: ICRUDOptions) {
    searchInput.onlyOfCreditors = this.showOnlyCreditors;
    searchInput.onlyOfDebitors = this.showOnlyDebitors;
    searchInput.onlyManufacturers = this.props?.onlyManufacturer;
    return super.executeSearch(searchInput, options);
  }

  getAddress() {
    if (this.formControl?.value?.address)
      return this.formControl.value?.address;
    else
      return (this.value() as AddressPostalLink)?.address;
  }

  showAddressSidebar() {
    this.sidebarVisible = true;
    let dialog: HTMLElement = document.querySelector('p-dialog');
    this.renderer.setStyle(dialog, 'z-index', '100');
  }

  isBlocked(a: AddressPostalLink) {
    if ((this.direction() === DocumentDirection.IN && a?.address?.documentBlockIn) || (this.direction() === DocumentDirection.OUT && a?.address?.documentBlockOut))
      return true;
    return false;
  }

}